export default "__VITE_ASSET__sY51IZVO__"